import React, {useEffect, useState} from 'react'
import {searchService} from 'services'
import requestHandler from 'utils/requestHandler'
import ProductsList from 'components/ProductsList'
import getPageSize from 'utils/getPageSize'

const pageSize = getPageSize()

const Products = ({match, data: dataProp}) => {
  const [data, setData] = useState((dataProp?.items) ? dataProp : undefined)

  useEffect(() => {
    requestHandler(() => searchService.prosugcat(match.params.searchValue), 'json')
      .then(r => {
        if (r.success) setData(r.data)
      })
  }, [match.params.searchValue])

  return (
    <div className='categoryProducts'>
      {data ? (
        <ProductsList
          mode='fullSearchResults'
          items={data.items}
          loadMoreRequest={(page) => searchService.prosugcat(match.params.searchValue, {take: pageSize, skip: page * pageSize})}
          setData={setData}
          searchValue={match.params.searchValue}
        />
      ) : (
        'loading...'
      )}
    </div>
  )
}

export default Products
